import axios from "axios";
import config from '../config'

export function getMetaversesInfo() {
    let url = `${config.URL}/api/info/metaverses`;
    return axios.get(url)
        .then((response) => {
            return response.data.data;
        });
}